export default "__VITE_ASSET__BsSVlTAb__"